import {
  CompanyName,
  CompanyPhoneNumber,
  FULL_BUSINESS_URL,
  SHARE_IMAGE_URL,
  SOCIAL_PROFILE_URLS,
} from '../Constants';
export const clipsPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: `${CompanyName} Clips & Fansites`,
  url: `${FULL_BUSINESS_URL}/clips-fansites`,
  description: `Unlock exclusive content, private clips, and premium experiences from ${CompanyName}. Indulge in My world beyond the ordinary.`,
  isPartOf: {
    '@type': 'WebSite',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
  },
  sameAs: SOCIAL_PROFILE_URLS,
};

export const clipsPageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} Clips & Fansites` },
  {
    property: 'og:description',
    content:
      `Access premium content, private clips, and exclusive fansite experiences from ${CompanyName}. Indulge in My world beyond the ordinary.`,
  },
  {
    property: 'og:image',
    content: SHARE_IMAGE_URL,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/clips-fansites` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} Clips & Fansites` },
  {
    name: 'twitter:description',
    content:
      'Explore a collection of My most exclusive content, available on premium clips and fansites.',
  },
  {
    name: 'twitter:image',
    content: SHARE_IMAGE_URL,
  },
];

export const galleryPageAdditionalMeta = [
  {
    property: 'og:title',
    content: `Gallery – ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Step into the visual world of ${CompanyName}. View exclusive images capturing the intensity and beauty of domination and submission.`,
  },
  { property: 'og:type', content: 'website' },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/gallery` },
  {
    property: 'og:image',
    content: SHARE_IMAGE_URL,
  },
];

// Domination Page Structured Data
export const dominationPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `Enter the Realm of Domination - ${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/services/domination`,
  description: `Surrender to the authority of ${CompanyName}. Explore the world of domination, discipline, and ultimate control.`,
  sameAs: SOCIAL_PROFILE_URLS,
};
// Sploshing Page Structured Data
export const sploshingPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `The Art of Sploshing - ${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/services/sploshing`,
  description: `Indulge in the messy, playful, and sensual world of sploshing with ${CompanyName}. A feast for the senses, where pleasure meets chaos.`,
  sameAs: SOCIAL_PROFILE_URLS,
};

// Wrestling Page Structured Data
export const wrestlingPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `Session Wrestling with ${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/services/wrestling`,
  description: `Experience the thrill of session wrestling with ${CompanyName}. Strength, dominance, and skill collide in an electrifying battle of power.`,
  sameAs: SOCIAL_PROFILE_URLS,
};

export const wrestlingPageAdditionalMeta = [
  {
    property: 'og:title',
    content: `Session Wrestling with ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Test your strength against ${CompanyName} in an intense and exhilarating session wrestling experience.`,
  },
  { property: 'og:image', content: SHARE_IMAGE_URL },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/services/wrestling` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Session Wrestling with ${CompanyName}`,
  },
  {
    name: 'twitter:description',
    content: `Enter the ring and experience the power, skill, and dominance of session wrestling with ${CompanyName}.`,
  },
  { name: 'twitter:image', content: SHARE_IMAGE_URL },
];

export const sploshingPageAdditionalMeta = [
  {
    property: 'og:title',
    content: `The Art of Sploshing - ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Enter a world of indulgence, where sensuality and mess intertwine. Experience the pleasure of sploshing with ${CompanyName}.`,
  },
  { property: 'og:image', content: SHARE_IMAGE_URL },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/services/sploshing` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `The Art of Sploshing - ${CompanyName}`,
  },
  {
    name: 'twitter:description',
    content: `Explore the messy, playful, and exhilarating world of sploshing with ${CompanyName}. A unique blend of fetish and fun.`,
  },
  { name: 'twitter:image', content: SHARE_IMAGE_URL },
];

export const dominationPageAdditionalMeta = [
  {
    property: 'og:title',
    content: `Enter the Realm of Domination - ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Experience the power and allure of ${CompanyName}. Discover a world of control, obedience, and submission.`,
  },
  { property: 'og:image', content: SHARE_IMAGE_URL },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/services/domination` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Enter the Realm of Domination - ${CompanyName}`,
  },
  {
    name: 'twitter:description',
    content: `Step into the domain of ${CompanyName} and embrace true submission. Only for those who dare.`,
  },
  { name: 'twitter:image', content: SHARE_IMAGE_URL },
];


export const galleryPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Gallery',
  description: `Discover the world of ${CompanyName} through our exclusive gallery. View captivating images from our sessions and experiences.`,
  url: `${FULL_BUSINESS_URL}/gallery`,
  image: SHARE_IMAGE_URL,
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: `${FULL_BUSINESS_URL}/`,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Gallery',
        item: `${FULL_BUSINESS_URL}/gallery`,
      },
    ],
  },
};

// About Me Page Meta and Structured Data
export const aboutPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: CompanyName,
  url: `${FULL_BUSINESS_URL}/about`,
  image: SHARE_IMAGE_URL,
  description:
    `Discover more about ${CompanyName}, a professional dominatrix, fetish specialist and wrestling empress based in Oldbury, West Midlands.`,
  jobTitle: `Professional Dominatrix`,
  sameAs: SOCIAL_PROFILE_URLS,
  knowsAbout: [
    'BDSM',
    'Dominance and Submission',
    'Fetish Exploration',
    'Session Wrestling',
    'Sploshing',
    'Discipline and Training',
  ],
};

export const aboutPageAdditionalMeta = [
  { property: 'og:title', content: `About ${CompanyName}` },
  {
    property: `og:description`,
    content:
      `Learn more about ${CompanyName}, a professional dominatrix, fetish specialist and wrestling empress based in Oldbury, West Midlands.`,
  },
  {
    property: 'og:image',
    content: SHARE_IMAGE_URL,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/about` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `About ${CompanyName}` },
  {
    name: `twitter:description`,
    content:
      `Discover the world of ${CompanyName}, a professional dominatrix, fetish specialist and wrestling empress based in Oldbury, West Midlands.`,
  },
  {
    name: `twitter:image`,
    content: SHARE_IMAGE_URL,
  },
];

// Services page
export const servicesPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${CompanyName} - Services`,
  url: `${FULL_BUSINESS_URL}/services`,
  description: `${CompanyName} offers exclusive BDSM services, including real-time sessions and private encounters designed to explore submission, dominance, and desire.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/services/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  sameAs: SOCIAL_PROFILE_URLS,
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: `${CompanyPhoneNumber}`,
    contactType: 'Customer Service',
    areaServed: 'GB',
    availableLanguage: ['English'],
  },
};

export const servicesPageAdditionalMeta = [
  { property: 'og:title', content: `Exclusive BDSM Services - ${CompanyName}` },
  {
    property: 'og:description',
    content:
      `Book your private BDSM session with ${CompanyName}. Discover personalized domination experiences that will leave you craving more.`,
  },
  { property: 'og:image', content: SHARE_IMAGE_URL },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/services` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Exclusive BDSM Services - ${CompanyName}`,
  },
  {
    name: 'twitter:description',
    content:
      `Explore our exclusive BDSM services and book a session with ${CompanyName} to experience true domination and submission.`,
  },
  { name: 'twitter:image', content: SHARE_IMAGE_URL },
];

// Links & Pay Sites Page
export const linksPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `Exclusive Links & Tribute Options - ${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/links`,
  description: `Discover all official ways to connect with ${CompanyName}, including premium content, tribute options, and private platforms.`,
  sameAs: SOCIAL_PROFILE_URLS,
};


export const linksPageAdditionalMeta = [
  {
    property: 'og:title',
    content: `Exclusive Links & Tribute Options - ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Explore all official platforms where you can connect, indulge, and tribute to ${CompanyName}.`,
  },
  { property: 'og:image', content: SHARE_IMAGE_URL },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/links` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Exclusive Links & Tribute Options - ${CompanyName}`,
  },
  {
    name: 'twitter:description',
    content: `Access premium content, tribute options, and exclusive ways to engage with ${CompanyName}.`,
  },
  { name: 'twitter:image', content: SHARE_IMAGE_URL },
];

// Blog Page
export const blogPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Blog',
  name: `${CompanyName} Blog`,
  url: `${FULL_BUSINESS_URL}/blog`,
  description: `The latest news, session availability, tour dates and updates from ${CompanyName}.`,
  publisher: {
    '@type': 'Organization',
    name: CompanyName,
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': `${FULL_BUSINESS_URL}/blog`,
  },
  sameAs: SOCIAL_PROFILE_URLS,
};

export const blogPageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} Blog` },
  {
    property: 'og:description',
    content: 'Stay updated with our latest articles and insights.',
  },
  { property: 'og:image', content: SHARE_IMAGE_URL },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/blog` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} Blog` },
  {
    name: 'twitter:description',
    content: `The latest news, session availability, tour dates and updates from ${CompanyName}.`,
  },
  { name: 'twitter:image', content: SHARE_IMAGE_URL },
];

// Blog Post Page Structured Data
export const blogPostStructuredData = (post) => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: post.title,
  description: post.description,
  datePublished: post.publishedAt,
  dateModified: post.publishedAt,
  author: {
    '@type': 'Person',
    name: post.author || `${CompanyName}`,
  },
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': `${FULL_BUSINESS_URL}/blog/${post.slug}`,
  },
  publisher: {
    '@type': 'Organization',
    name: CompanyName,
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
});

// Blog Post Page Meta Tags
export const blogPostAdditionalMeta = (post) => {
  const image = post.featuredImage
    ? `${FULL_BUSINESS_URL}${post.featuredImage}`
    : SHARE_IMAGE_URL;

  return [
    { property: 'og:type', content: 'article' },
    { property: 'og:title', content: post.title },
    { property: 'og:description', content: post.description },
    { property: 'og:image', content: image },
    { property: 'og:url', content: `${FULL_BUSINESS_URL}/blog/${post.slug}` },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: post.title },
    { name: 'twitter:description', content: post.description },
    { name: 'twitter:image', content: image },
  ];
};


// Forgot password
export const forgottenPasswordPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Reset Password',
  description: `Reset your password for your ${CompanyName} account.`,
  url: `${FULL_BUSINESS_URL}/forgotten-password`,
};

export const forgottenPasswordPageAdditionalMeta = [
  { property: 'og:title', content: `Reset Your Password - ${CompanyName}` },
  {
    property: 'og:description',
    content: `Securely reset your ${CompanyName} account password.`,
  },
  {
    property: 'og:image',
    content: SHARE_IMAGE_URL,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/forgotten-password` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Reset Your Password - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Follow the steps to securely reset your ${CompanyName} account password.`,
  },
  {
    name: 'twitter:image',
    content: SHARE_IMAGE_URL,
  },
];

// Login
export const loginPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Login',
  description: `Log in to your ${CompanyName} account to access exclusive features.`,
  url: `${FULL_BUSINESS_URL}/login`,
};

export const loginPageAdditionalMeta = [
  { property: 'og:title', content: `Login - ${CompanyName}` },
  {
    property: 'og:description',
    content: `Access your ${CompanyName} account to explore exclusive features and services.`,
  },
  {
    property: 'og:image',
    content: SHARE_IMAGE_URL,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/login` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Login - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Sign in to your ${CompanyName} account and unlock access to premium features.`,
  },
  {
    name: 'twitter:image',
    content: SHARE_IMAGE_URL,
  },
];

// Register
export const registerPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Register',
  description: `Create an account with ${CompanyName} to access exclusive features and services.`,
  url: `${FULL_BUSINESS_URL}/register`,
};

export const registerPageAdditionalMeta = [
  { property: 'og:title', content: `Register - ${CompanyName}` },
  {
    property: 'og:description',
    content: `Sign up for a ${CompanyName} account to enjoy exclusive features and personalized services.`,
  },
  {
    property: 'og:image',
    content: SHARE_IMAGE_URL,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/register` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Register - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Join ${CompanyName} today and unlock access to premium features.`,
  },
  {
    name: 'twitter:image',
    content: SHARE_IMAGE_URL,
  },
];


// Maintenance
export const maintenancePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Maintenance Page',
  description: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back soon!`,
  url: `${FULL_BUSINESS_URL}/down-for-maintenance`,
};

export const maintenancePageAdditionalMeta = [
  { property: 'og:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    property: 'og:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    property: 'og:image',
    content: SHARE_IMAGE_URL,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/down-for-maintenance` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    name: 'twitter:image',
    content: SHARE_IMAGE_URL,
  },
];

// Policies page
export const termsAndPoliciesStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Terms and Policies',
  description: `The terms of use and privacy policy for the ${CompanyName} website: adults only (18+), no personal data collected, and no cookies or tracking of any kind.`,
  url: `${FULL_BUSINESS_URL}/user-agreements`,
};

export const termsAndPoliciesAdditionalMeta = [
  { property: 'og:title', content: `Terms and Policies - ${CompanyName}` },
  {
    property: 'og:description',
    content: `The terms of use and privacy policy for the ${CompanyName} website: adults only (18+), no personal data collected, and no cookies or tracking.`,
  },
  {
    property: 'og:image',
    content: SHARE_IMAGE_URL,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/user-agreements` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Terms and Policies - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `The terms of use and privacy policy for the ${CompanyName} website: adults only (18+), no personal data collected, and no cookies or tracking.`,
  },
  {
    name: 'twitter:image',
    content: SHARE_IMAGE_URL,
  },
];

// Error page
export const errorPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '404 Error Page',
  description: `The requested page could not be found on ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/404`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const errorPageAdditionalMeta = [
  { property: 'og:title', content: 'Page Not Found - 404' },
  {
    property: 'og:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    property: 'og:image',
    content: SHARE_IMAGE_URL,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/404` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Page Not Found - 404' },
  {
    name: 'twitter:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    name: 'twitter:image',
    content: SHARE_IMAGE_URL,
  },
];
